<div [formGroup]="form">
  <div [formGroupName]="type">
    <ng-container *ngIf="question">
      <div class="question-label-container" [ngClass]="displayFieldCss(type+'.'+question.id)" *ngIf="question.label">
        <mat-label class="question-label h3">{{ question.label }}</mat-label>
      </div>

      <!-- SINGLE CHOICE QUESTIONS -->
      <ng-container *ngIf="!question.isMultipleChoice">
        <ng-container *ngFor="let answer of question.answers">
          <mat-form-field *ngIf="answer.inputType === 'number'" class="form-field form-full-width-field">
            <input matInput type="number"
                   [value]="(answer.text | number:'1.0-2') || ''"
                   [placeholder]="answer.label || question.label"
                   (input)="onKeyPress($event.target.value, null, question.id, answer)"
                   [disabled]="readOnly" />
          </mat-form-field>
        </ng-container>

        <mat-radio-group class="form-item radio-group" [formControlName]="createFormControlName(parentQuestion, question)">
          <ng-container *ngFor="let answer of question.answers">
            <mat-radio-button class="form-field radio-button" [value]="answer" *ngIf="answer.inputType !== 'number'">
              <span>{{answer.label}}</span>
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </ng-container>

      <!-- CHILD QUESTIONS -->
      <div *ngFor="let childQuestion of question.childQuestions"
           class="child-question-form-field"
           [ngClass]="type === 'OM' ? 'full-width' : ''">
        <mat-label class="question-label h3 child-question-label">{{ childQuestion.label }}</mat-label>
        <ng-container *ngFor="let childAnswer of childQuestion.answers">
          <mat-form-field  *ngIf="childAnswer.inputType === 'text'" class="form-field">
            <input matInput
                   [value]="childAnswer.text || ''"
                   [placeholder]="childAnswer.label || childQuestion.label"
                   (change)="onKeyPress($event.target.value, null, question.id+'-'+childQuestion.id, childAnswer)"
                   [disabled]="readOnly" />
          </mat-form-field>
          <mat-form-field  *ngIf="childAnswer.inputType === 'number'" class="form-field">
            <input matInput type="number"
                  [value]="(childAnswer.text | number:'1.0-2') || ''"
                  [placeholder]="childAnswer.label || childQuestion.label"
                  (change)="onKeyPress($event.target.value, null, question.id+'-'+childQuestion.id, childAnswer)"
                  [disabled]="readOnly" />
          </mat-form-field>
        </ng-container>
      </div>

      <!-- MULTIPLE CHOICE QUESTIONS: multi choice questions have another form group that single choice questions don't -->
      <ng-container *ngIf="question.isMultipleChoice" [formGroupName]="question.id">
        <div class="row">
          <ng-container *ngFor="let answer of question.answers">
            <mat-form-field *ngIf="answer.inputType === 'number'"
                            [ngClass]="type === 'TB' ? 'col-xs-4 form-item' : 'form-field form-full-width-field'">
              <input matInput type="number"
                     [value]="(answer.text | number:'1.0-2') || ''"
                     [placeholder]="answer.label || question.label"
                     (input)="onKeyPress($event.target.value, question.id, answer.id, answer)"
                     [disabled]="readOnly" />
            </mat-form-field>
            <mat-radio-group class="form-item radio-group"
                             *ngIf="answer.inputType !== 'number'"
                             [class.has-images]="question.answers[0].imagePath"
                             [formControlName]="createFormControlName(parentQuestion, question)">
              <mat-radio-button class="form-field" [value]="answer">
                <img *ngIf="answer.imagePath" [src]="(imagePath + answer.imagePath).toLowerCase()" />
                <span>{{answer.label}}</span>
              </mat-radio-button>
            </mat-radio-group>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
